module.exports = __webpack_public_path__ + "static/media/igen.ed83bea9.svg";